import { defineMessages } from 'react-intl';

export default defineMessages({
    noteSentConfirmation: {
        id: 'adac.send-note-page.Note was sent successfuly',
        defaultMessage: 'Note was sent successfuly'
    },
    callbackNeeded: {
        id: 'adac.send-note-page.Callback needed',
        defaultMessage: 'Callback needed'
    },
    noteContent: {
        id: 'adac.send-note-page.Note',
        defaultMessage: 'Note'
    },
    previousMessagesTitle: {
        id: 'adac.send-note-page.Previous Messages:',
        defaultMessage: 'Previous Messages:'
    },
    activityOpenError: {
        id: 'adac.send-note-page.Your message has already been sent. It is currently not possible to send another message as long as the first message has not been processed.',
        defaultMessage: 'Your message has already been sent. It is currently not possible to send another message as long as the first message has not been processed.'
    }
});
